import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { serviceNames } from '../../constant'
import { useAllprojectsQuery } from '../../helpers/projectsApi'
import Loader from '../Loader/Loader'
import PortfolioSlider from '../PortfolioSlider/PortfolioSlider'

const RecentWork = ({ data, reviewData }) => {

    let page = 1

    const [slug, setslug] = useState()

    const { data: projectData, isFetching } = useAllprojectsQuery({ slug, page })

    const location = useLocation()

    useEffect(() => {

        let x = location.pathname
        x = x.split('/')[1]

        let isSlugExist = serviceNames.filter(item => item === x)

        if (isSlugExist.length) {
            setslug(isSlugExist[0])
        }

    }, [location])



    return (
        <div>
            <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-4 md:px-12'>
                {isFetching ? <Loader text='Loading projects...' height={'50vh'} /> : (
                    <div>
                        {projectData.projects.length > 0 && (
                            <div>
                                <div>
                                    <h1
                                        className='text-xl md:text-2xl font-bold text-center dark:text-white'
                                    >
                                        Our Recent <span className='text-yellow-500'>Projects</span>
                                    </h1>

                                </div>
                                <div className='mt-10'>
                                    <PortfolioSlider data={projectData.projects} reviewData={reviewData} />
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default RecentWork